import { Factory } from 'rosie';

Factory.define('ReportBuilderConfig').attr('name', 'REPORT_BUILDER_CONFIG');

Factory.define('ReportBuilderConfigWithDefaults')
  .extend('ReportBuilderConfig')
  .attr('enabled', true);
